export const CONSULTORIA_PRE_CIRURGICA_BASE_PATH = '/consultoria-pre-cirurgica'

/**
 * Identifica a landing de consultoria e sub-rotas futuras
 * (ex.: /consultoria-pre-cirurgica, /consultoria-pre-cirurgica/, /consultoria-pre-cirurgica/obrigado).
 */
export function isConsultoriaPreCirurgicaRoute(pathname) {
  const normalized = pathname.replace(/\/+$/, '') || '/'

  return (
    normalized === CONSULTORIA_PRE_CIRURGICA_BASE_PATH ||
    normalized.startsWith(`${CONSULTORIA_PRE_CIRURGICA_BASE_PATH}/`)
  )
}
